<template>
    <div class="c-row">
        <div class="c-tr p-3">
            <img class="img-fluid" :src="data" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: String,
            required: true
        }
    }
}
</script>
